module.exports = __webpack_public_path__ + "media/icons/empty-star-5222c40a.svg";